import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CheckoutState {
	deliveryFee: number | null;
}

const initialState: CheckoutState = {
	deliveryFee: null,
};

export const checkoutSlice = createSlice({
	name: "checkout",
	initialState,
	reducers: {
		setDeliveryFee: (state: CheckoutState, action: PayloadAction<number>) => {
			state.deliveryFee = action.payload;
		},
		resetCheckoutState: (state: CheckoutState) => {
			state.deliveryFee = null;
		},
	},
});

export const { setDeliveryFee, resetCheckoutState } = checkoutSlice.actions;

export default checkoutSlice.reducer;
